// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

import { EnterpriseContractTagsV1 } from './EnterpriseContractTagsV1';
import { EnterpriseContractsV1 } from './EnterpriseContractsV1';
import { ProgramBrowsingExperiencesV1 } from './ProgramBrowsingExperiencesV1';
import { ProgramCurriculumCollectionsV1 } from './ProgramCurriculumCollectionsV1';
import { ProgramCurriculumDomainsV1 } from './ProgramCurriculumDomainsV1';
import { ProgramMembershipsV1 } from './ProgramMembershipsV1';
import { ThirdPartyOrganizationsV1 } from './ThirdPartyOrganizationsV1';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type SkillSetAvailabilityType = 'ALL_SKILLSETS' | 'LINKED_SKILLSETS_ONLY';

export interface ProgramMetadata {
  slug: string;
  name: string;
  tagline?: string | null;
  description?: string | null;
  logo?: string | null;
  landingPageBanner?: string | null;
  tutorialVideoUrl?: string | null;
  tutorialVideoAssetId?: string | null;
  launchedAt?: number | null;
  endedAt?: number | null;
  curriculumId: string;
  isLocked: boolean;
  linkedTargetSkillProfileIds: Array<string>;
  skillSetAvailabilityType: SkillSetAvailabilityType;
  linkedAcademicDisciplineIds: Array<string>;
  primaryColor?: string | null;
  rectangularLogo?: string | null;
  squareLogo?: string | null;
}

export interface EnterpriseProgramsV1 {
  id: string;
  metadata: ProgramMetadata;
  thirdPartyOrganizationId: string;
  contractId?: string | null;
  maxCoursesPerUser?: number | null;
}

export interface EnterpriseProgram {
  metadata: ProgramMetadata;
  thirdPartyOrganizationId: string;
  contractId?: string | null;
  maxCoursesPerUser?: number | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseProgramsV1Connection {
  elements: Array<EnterpriseProgramsV1> | null;
  linked: {
    programBrowsingExperiencesV1: Array<ProgramBrowsingExperiencesV1> | null;
    thirdPartyOrganizationsV1: Array<ThirdPartyOrganizationsV1> | null;
    programMembershipsV1: Array<ProgramMembershipsV1> | null;
    programCurriculumDomainsV1: Array<ProgramCurriculumDomainsV1> | null;
    programCurriculumCollectionsV1: Array<ProgramCurriculumCollectionsV1> | null;
    enterpriseContractTagsV1: Array<EnterpriseContractTagsV1> | null;
    enterpriseContractsV1: Array<EnterpriseContractsV1> | null;
  } | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterpriseProgramsV1ByContractIdQuery {
  EnterpriseProgramsV1: {
    byContractId: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1ByContractIdQueryVariables {
  enterpriseContractId: string;
  includeArchived?: string | null;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1ByCurriculumIdQuery {
  EnterpriseProgramsV1: {
    byCurriculumId: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1ByCurriculumIdQueryVariables {
  curriculumId: string;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1ByOrganizationAndSkillsetIdQuery {
  EnterpriseProgramsV1: {
    byOrganizationAndSkillsetId: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1ByOrganizationAndSkillsetIdQueryVariables {
  thirdPartyOrganizationId: string;
  unifiedSkillsetId: string;
  includeArchived?: string | null;
  includeProgramsWithAllSkillsets?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1ByOrganizationSlugQuery {
  EnterpriseProgramsV1: {
    byOrganizationSlug: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1ByOrganizationSlugQueryVariables {
  organizationSlug: string;
  includeArchived?: string | null;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1ByTargetSkillProfileIdQuery {
  EnterpriseProgramsV1: {
    byTargetSkillProfileId: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1ByTargetSkillProfileIdQueryVariables {
  targetSkillProfileId: string;
  includeArchived?: string | null;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1ByThirdPartyOrganizationIdQuery {
  EnterpriseProgramsV1: {
    byThirdPartyOrganizationId: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1ByThirdPartyOrganizationIdQueryVariables {
  thirdPartyOrganizationId: string;
  includeArchived?: string | null;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1GetQuery {
  EnterpriseProgramsV1: {
    get: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1GetQueryVariables {
  id: string;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1GetAllQuery {
  EnterpriseProgramsV1: {
    getAll: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1GetAllQueryVariables {
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1GetVersionedQuery {
  EnterpriseProgramsV1: {
    getVersioned: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1GetVersionedQueryVariables {
  id: string;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1MultiGetQuery {
  EnterpriseProgramsV1: {
    multiGet: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1MultiGetQueryVariables {
  ids: string;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1SlugQuery {
  EnterpriseProgramsV1: {
    slug: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1SlugQueryVariables {
  slug: string;
  eventualConsistency?: string | null;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface EnterpriseProgramsV1ArchiveMutation {
  EnterpriseProgramsV1: {
    archive: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1ArchiveMutationVariables {
  id: string;
  includeCleanup?: string | null;
  sendMembershipDeletionNotification?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1CreateMutation {
  EnterpriseProgramsV1: {
    create: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1CreateMutationVariables {
  includes?: string | null;
}

export interface EnterpriseProgramsV1GetLatestVersionMutation {
  EnterpriseProgramsV1: {
    getLatestVersion: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1GetLatestVersionMutationVariables {
  id: string;
  eventualConsistency?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1MultiLockMutation {
  EnterpriseProgramsV1: {
    multiLock: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1MultiLockMutationVariables {
  ids: string;
  includes?: string | null;
}

export interface EnterpriseProgramsV1MultiUnlockMutation {
  EnterpriseProgramsV1: {
    multiUnlock: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1MultiUnlockMutationVariables {
  ids: string;
  includes?: string | null;
}

export interface EnterpriseProgramsV1SetProgramLimitsMutation {
  EnterpriseProgramsV1: {
    setProgramLimits: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1SetProgramLimitsMutationVariables {
  enterpriseContractId: string;
  limit?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1UpdateMutation {
  EnterpriseProgramsV1: {
    update: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1UpdateMutationVariables {
  id: string;
  skipValidation?: string | null;
  input: EnterpriseProgram;
  includes?: string | null;
}

export interface EnterpriseProgramsV1UpdateAcademicDisciplineMutation {
  EnterpriseProgramsV1: {
    updateAcademicDiscipline: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1UpdateAcademicDisciplineMutationVariables {
  id: string;
  academicDisciplineId: string;
  userId?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1UpdateSkillsetAvailabilityTypeMutation {
  EnterpriseProgramsV1: {
    updateSkillsetAvailabilityType: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1UpdateSkillsetAvailabilityTypeMutationVariables {
  includes?: string | null;
}

export interface EnterpriseProgramsV1UpdateTargetSkillProfilesMutation {
  EnterpriseProgramsV1: {
    updateTargetSkillProfiles: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1UpdateTargetSkillProfilesMutationVariables {
  id: string;
  userId?: string | null;
  includes?: string | null;
}

export interface EnterpriseProgramsV1ValidateSlugMutation {
  EnterpriseProgramsV1: {
    validateSlug: EnterpriseProgramsV1Connection | null;
  } | null;
}

export interface EnterpriseProgramsV1ValidateSlugMutationVariables {
  slug: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class EnterpriseProgramsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterprisePrograms.v1' as const;

  declare id: string;

  declare metadata: ProgramMetadata;

  declare thirdPartyOrganizationId: string;

  declare contractId?: string | null;

  declare maxCoursesPerUser?: number | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseProgramsV1>) {
    super(params);
  }
}
